import Physician from "../../../Physician/Models/Physician";
import CCBlockSummaryActivitiesMeeting from "./CCBlockSummaryActivitiesMeeting";
import CCBlockSummaryActivitiesNotMeeting from "./CCBlockSummaryActivitiesNotMeeting";


interface IProps{
    physician: Physician;
    showNotMeeting: boolean;
}

export default function CCBlockSummaryActivitiesCard(props: IProps) {

     if (props.showNotMeeting){
         return (
             <CCBlockSummaryActivitiesNotMeeting physician={props.physician} />);
     }
     else {
         return( 
             <CCBlockSummaryActivitiesMeeting physician={props.physician} />);
     }  
}